import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { getSessonId } from "../../Utility/axiosInstances";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";
import Chip from "@mui/material/Chip";

import { useNavigate,useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import Switch from "@mui/material/Switch";
import moment from "moment/moment";

const CreatePopup = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [popupName, setPopupName] = useState("");
  const [title, setTitle] = useState("");
  const [des, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [code, setCode] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState("");
  const [webimage,setWebImage] = useState("");
  const [link, setLink] = useState("");
  const [cutoffdate, setCutoffdate] = useState("");
  const [cutofftime, setCutofftime] = useState("");
  const [startdate, setStartdate] = useState("");
  const [startTime, setStartTime] = useState("");
  const[starting,setStarting] = useState("");
  const[ending,setEnding] = useState("");
  const[startTiming,setStartTiming] = useState("");
  const[endTiming,setEndTiming] = useState("");
  const[userlist,setUserList] = useState(" ");
  const [customerIds, setCustomerIds] = useState('');
  const [playerList, setPlayerList] = useState([]);
  const [excludePlayerTypes, setExcludePlayerTypes] = useState([]);
  const [attempt, setAttempt] = useState("");
  const [sort, setSort] = useState(0);

  const params = useParams();

  useEffect(() => {
    getAllData(endPoints.api.playertypes)
      .then((response) => {
        if (response.status === "success") setPlayerList(response.data);
      })
      .catch(() => {});
  }, []);

  const handlePlayerTypeChange = (playerId) => {
    setExcludePlayerTypes((prev) =>
      prev.includes(playerId) ? prev.filter((id) => id !== playerId) : [...prev, playerId]
    );
  };

  useEffect(()=>{


    if (startdate || startTime) {
    
      setStarting(startdate.concat("",startTime));

      setStartTiming(moment(starting, 'YYYY-MM-DDHH:mm').format('YYYY-MM-DDTHH:mm:ss'));

    }

    if (cutoffdate || cutofftime) {

     setEnding(cutoffdate.concat("",cutofftime));

     setEndTiming(moment(ending, 'YYYY-MM-DDHH:mm').format('YYYY-MM-DDTHH:mm:ss'));

    }

  })


  React.useEffect(() => {
    if (open) {
      // console.log("data",editData,Object.keys(editData).length);

      if(Object.keys(editData).length===0){

      setPopupName("");
      setTitle(editData?.title);
      setDescription(editData?.description);
      setIsActive(editData?.isActive);
      setImage(editData?.mobile_image);
      setWebImage(editData?.web_image);
      setUserList(editData?.user_list);
      setAttempt("");
      setSort("");
      setLink(editData?.link);
      setExcludePlayerTypes([]);
      setCutoffdate("");
      setCutofftime("");
      setStartdate("");
      setStartTime("");
      }
      else{

        setPopupName(editData?.title || "");
        setTitle(editData?.title);
        setDescription(editData?.description);
        setIsActive(editData?.isActive || false);
        setImage(editData?.mobile_image);
        setWebImage(editData?.web_image);
        setUserList(editData?.user_list);
        setAttempt(editData?.login_attempt);
        setSort(editData?.sort || "");
        setLink(editData?.link);
        setExcludePlayerTypes(editData?.exclude_player || []);
        setCutoffdate(moment.utc(editData?.cuttoffTime).format('YYYY-MM-DD'));
        setCutofftime(moment.utc(editData?.cuttoffTime).format('HH:mm'));
        setStartdate(moment.utc(editData?.startTime).format('YYYY-MM-DD'));
        setStartTime(moment.utc(editData?.startTime).format('HH:mm'));
      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  const onImageChange = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      // Validate file type
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validImageTypes.includes(files[0].type)) {
        ErrorToast("Please upload a valid image file (JPEG, PNG, GIF, or WEBP)");
        event.target.value = '';
        return;
      }
      // // Validate file size (5MB limit)
      // if (files[0].size > 5 * 1024 * 1024) {
      //   ErrorToast("Image size should be less than 5MB");
      //   event.target.value = '';
      //   return;
      // }
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      UploadImage(url, files[0]);
    }
  };

  const onImageWebChange = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      // Validate file type
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
      if (!validImageTypes.includes(files[0].type)) {
        ErrorToast("Please upload a valid image file (JPEG, PNG, GIF, or WEBP)");
        event.target.value = '';
        return;
      }
      // // Validate file size (5MB limit)
      // if (files[0].size > 5 * 1024 * 1024) {
      //   ErrorToast("Image size should be less than 5MB");
      //   event.target.value = '';
      //   return;
      // }
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      UploadWebImage(url, files[0]);
    }
  };

  const onuserUpload = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      uploadUser(url, files[0]);
    }
  };

  const uploadUser = (url, files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: getSessonId() ? { SessonId: getSessonId() } : {},
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setUserList(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  // console.log("userlist",`${endPoints.apiBaseUrl}${userlist}`);

  const UploadImage = (url, files) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: getSessonId() ? { SessonId: getSessonId() } : {},
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        SuccesToast(result.message);
        setIsLoading(false);
        setImage(result.data);
      })
      .catch((error) => console.log("error", error));
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      // Assuming the CSV contains only one column of customer IDs
      const idsArray = text.split('\n').map(row => row.trim());
      const user_ids = idsArray.join(',');
      setCustomerIds(user_ids);

      // Log the concatenated customer IDs to the console
      // console.log("Customer IDs:", user_ids);
    };

    reader.readAsText(file);
  };


  const UploadWebImage = (url, files) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: getSessonId() ? { SessonId: getSessonId() } : {},
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        SuccesToast(result.message);
        setIsLoading(false);
        setWebImage(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const handleOk = () => {
    // Validate required fields
    if (!popupName || !des || !startdate || !startTime || !cutoffdate || !cutofftime || !image || !webimage || !attempt) {
      ErrorToast("Please fill the required fields");
      return;
    }

    // Validate dates
    const startDateTime = new Date(`${startdate}T${startTime}`);
    const cutoffDateTime = new Date(`${cutoffdate}T${cutofftime}`);
    const currentDateTime = new Date();

    if (isNaN(startDateTime.getTime()) || isNaN(cutoffDateTime.getTime())) {
      ErrorToast("Invalid date or time format");
      return;
    }

    if (cutoffDateTime <= startDateTime) {
      ErrorToast("Cutoff date/time must be after start date/time");
      return;
    }

    let url = editData?.id
      ? `${endPoints.api.UPDATE_POPUP}`
      : `${endPoints.api.ADD_POPUP}`;

      //  const newids = `${endPoints.apiBaseUrl}${userlist}`

      // const idsArray = newids.split('\n').map(row => row.trim());
      // const concatenatedIds = idsArray.join(',');
      // setCustomerIds(concatenatedIds);
      // console.log("Customer IDs:", concatenatedIds);

      // "title":"Test tile","description":"Hi Tested","mobile_image":"mbimgae","web_image":"webimage","user_list":"user",
      // "link":"link","isActive":true,"login_attempt":2,"startTime":"2024-02-07T07:31:56.000+0000",
      // "cuttoffTime":"2024-02-07T07:31:56.000+0000","created_on":"2024-02-07T07:31:56.000+0000",
      // "updated_on":"2024-02-07T07:31:56.000+0000","id":1

    let payload = {
      title: popupName || "",
      description: des || "",
      mobile_image: image || "",
      web_image: webimage || "",
      user_list: editData?.id && customerIds ? customerIds : editData?.id && customerIds == "" ? editData.user_list : customerIds || "",
      exclude_player: excludePlayerTypes || [],
      link: link || "",
      isActive: isActive || false,
      login_attempt: attempt || 0,
      login_count: 0,
      click_count: 0,
      sort: parseInt(sort),
      startTime: startTiming || "",
      cuttoffTime: endTiming || "",
      // startdate:startdate,
      // starttime:startTime,
      // cutoffdate:cutoffdate,
      // cutofftime:cutofftime
    };

    // console.log("payload",webimage);

    if (editData?.id) {
      payload.id = editData.id;
    }
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          // console.log("image",image);
          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Banner Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Popup Name"
            value={popupName}
            onChange={(event) => {
              setPopupName(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Message"
            value={des}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Button name"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
            }}
          />
        </FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="CTA"
            value={link}
            onChange={(event) => {
              setLink(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Attempt</label>
          <TextField
            id="filled-required"
            variant="outlined"
            type="number"
            inputProps={{ max: 5, min: 1 }}
            value={attempt}
            onChange={(event) => {
              const value = event.target.value;
              if (value === '' || parseInt(value) >= 1) {
                setAttempt(value);
              }
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Sort</label>
          <TextField
            id="filled-required"
            variant="outlined"
            type="number"
            inputProps={{ min: 1 }}
            value={sort}
            onChange={(event) => {
              const value = event.target.value;
              if (value === '' || parseInt(value) >= 1) {
                setSort(value);
              }
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Date</label>
        {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="date"
            value={startdate}
            onChange={(event) => {
              setStartdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Time</label>
        {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="time"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Cutoff Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Date"
            type="date"
            value={cutoffdate}
            onChange={(event) => {
              setCutoffdate(event.target.value);
            }}
          />
        </FormControl>
        

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
        <label>Cutoff Time</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="time"
            value={cutofftime}
            onChange={(event) => {
              setCutofftime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <label style={{marginTop:"25px"}}>Mobile Image</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={image}
        onChange={onImageChange}
        type="file" 
        />

        <label style={{marginTop:"5px"}}>Web Image</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={webimage}
        onChange={onImageWebChange}
        type="file" 
        />

        {/* <label style={{marginTop:"5px"}}>Upload User List</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={userlist}
        onChange={onuserUpload}
        type="file" 
        /> */}

    {/* <label style={{marginTop:"5px"}}>Upload User List</label> 
        <Form.Control
        style={{marginBottom:"20px",width: "100%"}} 
        id="filled-required"
        variant="outlined"
        label="image"
        // value={image}
        name={userlist}
        type="file" 
        onChange={handleFileUpload} 
        accept=".csv"
        /> */}

        <div style={{ marginTop: "20px" }}>
          <Form.Label style={{ fontWeight: "bold" }}>Exclude Player Type</Form.Label>
          <FormControl fullWidth size="small">
            <Select
              multiple
              displayEmpty
              value={excludePlayerTypes}
              onChange={(e) =>
                setExcludePlayerTypes(
                  (typeof e.target.value === "string"
                    ? e.target.value.split(",")
                    : e.target.value
                  ).map(Number)
                )
              }
              input={<OutlinedInput />}
              renderValue={(selected) => {
                if (!selected || selected.length === 0) {
                  return (
                    <span style={{ color: "#8990b8" }}>
                      Select player types to exclude
                    </span>
                  );
                }
                return (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                    {selected.map((id) => {
                      const p = playerList.find((x) => x.id === id);
                      return (
                        <Chip key={id} size="small" label={p ? p.player_type : id} />
                      );
                    })}
                  </div>
                );
              }}
              MenuProps={{ PaperProps: { style: { maxHeight: 320 } }, sx: { zIndex: 1600 } }}
            >
              {playerList.map((player) => (
                <MenuItem key={player.id} value={player.id}>
                  <Checkbox checked={excludePlayerTypes.includes(player.id)} />
                  <ListItemText primary={player.player_type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <FormControlLabel
          style={{ marginTop: "10px" }}
          control={
            <Switch
              name="active"
              value={isActive}
              onClick={() => {
                setIsActive(!isActive);
              }}
              defaultChecked={isActive}
            />
          }
          labelPlacement="start"
          label="Active"
        />

        {/* <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Price"
            value={price}
            onChange={(event) => {
              setPrice(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Code"
            value={code}
            //  type="number"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCode(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Player Count"
            value={playerCount}
            onChange={(event) => {
              setPlayerCount(event.target.value);
            }}
          />
        </FormControl> */}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePopup;
